module.exports = __webpack_public_path__ + "dc890d14a39c84173c949c679e8cc746.svg";